import type { SvgIconComponent } from '@mui/icons-material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import type { DialogVariant } from './ConfirmDialog.types';

/**
 * Configuration for each dialog variant
 * Defines icon, colors, and visual treatment
 */
export interface VariantConfig {
  /** Icon component to display */
  icon: SvgIconComponent;
  /** Main variant color (for icon and border) */
  color: string;
  /** Semantic name */
  name: string;
}

/**
 * Variant configurations matching MUI Alert severity pattern
 */
export const VARIANT_CONFIG: Record<DialogVariant, VariantConfig> = {
  warning: {
    name: 'Warning',
    icon: ErrorOutlineIcon,
    color: '#FA9048', // Custom warning orange
  },
  error: {
    name: 'Error',
    icon: HighlightOffIcon,
    color: '#D11A9A', // Custom error red
  },
  info: {
    name: 'Info',
    icon: InfoOutlinedIcon,
    color: '#0288D1', // MUI info blue
  },
  success: {
    name: 'Success',
    icon: CheckCircleOutlineIcon,
    color: '#33E081', // Custom success green
  },
} as const;

/**
 * Get configuration for a specific variant
 */
export const getVariantConfig = (variant: DialogVariant): VariantConfig => {
  return VARIANT_CONFIG[variant];
};
